/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ContextModuleDTO } from '../model/contextModuleDTO';

import { AIG_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ContextModuleResourceService {

    protected basePath = 'https://api-gest.eneasys.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(AIG_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * countContextModules
     * 
     * @param activeEquals 
     * @param activeIn 
     * @param activeNotEquals 
     * @param activeSpecified 
     * @param contextIdEquals 
     * @param contextIdGreaterThan 
     * @param contextIdGreaterThanOrEqual 
     * @param contextIdIn 
     * @param contextIdLessThan 
     * @param contextIdLessThanOrEqual 
     * @param contextIdNotEquals 
     * @param contextIdSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param moduleIdEquals 
     * @param moduleIdGreaterThan 
     * @param moduleIdGreaterThanOrEqual 
     * @param moduleIdIn 
     * @param moduleIdLessThan 
     * @param moduleIdLessThanOrEqual 
     * @param moduleIdNotEquals 
     * @param moduleIdSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countContextModulesUsingGET(activeEquals?: boolean, activeIn?: Array<boolean>, activeNotEquals?: boolean, activeSpecified?: boolean, contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countContextModulesUsingGET(activeEquals?: boolean, activeIn?: Array<boolean>, activeNotEquals?: boolean, activeSpecified?: boolean, contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countContextModulesUsingGET(activeEquals?: boolean, activeIn?: Array<boolean>, activeNotEquals?: boolean, activeSpecified?: boolean, contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countContextModulesUsingGET(activeEquals?: boolean, activeIn?: Array<boolean>, activeNotEquals?: boolean, activeSpecified?: boolean, contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





























        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (activeEquals !== undefined && activeEquals !== null) {
            queryParameters = queryParameters.set('active.equals', <any>activeEquals);
        }
        if (activeIn) {
            activeIn.forEach((element) => {
                queryParameters = queryParameters.append('active.in', <any>element);
            })
        }
        if (activeNotEquals !== undefined && activeNotEquals !== null) {
            queryParameters = queryParameters.set('active.notEquals', <any>activeNotEquals);
        }
        if (activeSpecified !== undefined && activeSpecified !== null) {
            queryParameters = queryParameters.set('active.specified', <any>activeSpecified);
        }
        if (contextIdEquals !== undefined && contextIdEquals !== null) {
            queryParameters = queryParameters.set('contextId.equals', <any>contextIdEquals);
        }
        if (contextIdGreaterThan !== undefined && contextIdGreaterThan !== null) {
            queryParameters = queryParameters.set('contextId.greaterThan', <any>contextIdGreaterThan);
        }
        if (contextIdGreaterThanOrEqual !== undefined && contextIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contextId.greaterThanOrEqual', <any>contextIdGreaterThanOrEqual);
        }
        if (contextIdIn) {
            contextIdIn.forEach((element) => {
                queryParameters = queryParameters.append('contextId.in', <any>element);
            })
        }
        if (contextIdLessThan !== undefined && contextIdLessThan !== null) {
            queryParameters = queryParameters.set('contextId.lessThan', <any>contextIdLessThan);
        }
        if (contextIdLessThanOrEqual !== undefined && contextIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contextId.lessThanOrEqual', <any>contextIdLessThanOrEqual);
        }
        if (contextIdNotEquals !== undefined && contextIdNotEquals !== null) {
            queryParameters = queryParameters.set('contextId.notEquals', <any>contextIdNotEquals);
        }
        if (contextIdSpecified !== undefined && contextIdSpecified !== null) {
            queryParameters = queryParameters.set('contextId.specified', <any>contextIdSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (moduleIdEquals !== undefined && moduleIdEquals !== null) {
            queryParameters = queryParameters.set('moduleId.equals', <any>moduleIdEquals);
        }
        if (moduleIdGreaterThan !== undefined && moduleIdGreaterThan !== null) {
            queryParameters = queryParameters.set('moduleId.greaterThan', <any>moduleIdGreaterThan);
        }
        if (moduleIdGreaterThanOrEqual !== undefined && moduleIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('moduleId.greaterThanOrEqual', <any>moduleIdGreaterThanOrEqual);
        }
        if (moduleIdIn) {
            moduleIdIn.forEach((element) => {
                queryParameters = queryParameters.append('moduleId.in', <any>element);
            })
        }
        if (moduleIdLessThan !== undefined && moduleIdLessThan !== null) {
            queryParameters = queryParameters.set('moduleId.lessThan', <any>moduleIdLessThan);
        }
        if (moduleIdLessThanOrEqual !== undefined && moduleIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('moduleId.lessThanOrEqual', <any>moduleIdLessThanOrEqual);
        }
        if (moduleIdNotEquals !== undefined && moduleIdNotEquals !== null) {
            queryParameters = queryParameters.set('moduleId.notEquals', <any>moduleIdNotEquals);
        }
        if (moduleIdSpecified !== undefined && moduleIdSpecified !== null) {
            queryParameters = queryParameters.set('moduleId.specified', <any>moduleIdSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/m8t/api/context-modules/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createContextModule
     * 
     * @param body contextModuleDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createContextModuleUsingPOST(body: ContextModuleDTO, observe?: 'body', reportProgress?: boolean): Observable<ContextModuleDTO>;
    public createContextModuleUsingPOST(body: ContextModuleDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContextModuleDTO>>;
    public createContextModuleUsingPOST(body: ContextModuleDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContextModuleDTO>>;
    public createContextModuleUsingPOST(body: ContextModuleDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createContextModuleUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ContextModuleDTO>('post',`${this.basePath}/m8t/api/context-modules`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteContextModule
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteContextModuleUsingDELETE(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteContextModuleUsingDELETE(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteContextModuleUsingDELETE(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteContextModuleUsingDELETE(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteContextModuleUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/m8t/api/context-modules/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllContextModules
     * 
     * @param activeEquals 
     * @param activeIn 
     * @param activeNotEquals 
     * @param activeSpecified 
     * @param contextIdEquals 
     * @param contextIdGreaterThan 
     * @param contextIdGreaterThanOrEqual 
     * @param contextIdIn 
     * @param contextIdLessThan 
     * @param contextIdLessThanOrEqual 
     * @param contextIdNotEquals 
     * @param contextIdSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param moduleIdEquals 
     * @param moduleIdGreaterThan 
     * @param moduleIdGreaterThanOrEqual 
     * @param moduleIdIn 
     * @param moduleIdLessThan 
     * @param moduleIdLessThanOrEqual 
     * @param moduleIdNotEquals 
     * @param moduleIdSpecified 
     * @param page Page number of the requested page
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllContextModulesUsingGET(activeEquals?: boolean, activeIn?: Array<boolean>, activeNotEquals?: boolean, activeSpecified?: boolean, contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<ContextModuleDTO>>;
    public getAllContextModulesUsingGET(activeEquals?: boolean, activeIn?: Array<boolean>, activeNotEquals?: boolean, activeSpecified?: boolean, contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContextModuleDTO>>>;
    public getAllContextModulesUsingGET(activeEquals?: boolean, activeIn?: Array<boolean>, activeNotEquals?: boolean, activeSpecified?: boolean, contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContextModuleDTO>>>;
    public getAllContextModulesUsingGET(activeEquals?: boolean, activeIn?: Array<boolean>, activeNotEquals?: boolean, activeSpecified?: boolean, contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, moduleIdEquals?: number, moduleIdGreaterThan?: number, moduleIdGreaterThanOrEqual?: number, moduleIdIn?: Array<number>, moduleIdLessThan?: number, moduleIdLessThanOrEqual?: number, moduleIdNotEquals?: number, moduleIdSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (activeEquals !== undefined && activeEquals !== null) {
            queryParameters = queryParameters.set('active.equals', <any>activeEquals);
        }
        if (activeIn) {
            activeIn.forEach((element) => {
                queryParameters = queryParameters.append('active.in', <any>element);
            })
        }
        if (activeNotEquals !== undefined && activeNotEquals !== null) {
            queryParameters = queryParameters.set('active.notEquals', <any>activeNotEquals);
        }
        if (activeSpecified !== undefined && activeSpecified !== null) {
            queryParameters = queryParameters.set('active.specified', <any>activeSpecified);
        }
        if (contextIdEquals !== undefined && contextIdEquals !== null) {
            queryParameters = queryParameters.set('contextId.equals', <any>contextIdEquals);
        }
        if (contextIdGreaterThan !== undefined && contextIdGreaterThan !== null) {
            queryParameters = queryParameters.set('contextId.greaterThan', <any>contextIdGreaterThan);
        }
        if (contextIdGreaterThanOrEqual !== undefined && contextIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contextId.greaterThanOrEqual', <any>contextIdGreaterThanOrEqual);
        }
        if (contextIdIn) {
            contextIdIn.forEach((element) => {
                queryParameters = queryParameters.append('contextId.in', <any>element);
            })
        }
        if (contextIdLessThan !== undefined && contextIdLessThan !== null) {
            queryParameters = queryParameters.set('contextId.lessThan', <any>contextIdLessThan);
        }
        if (contextIdLessThanOrEqual !== undefined && contextIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contextId.lessThanOrEqual', <any>contextIdLessThanOrEqual);
        }
        if (contextIdNotEquals !== undefined && contextIdNotEquals !== null) {
            queryParameters = queryParameters.set('contextId.notEquals', <any>contextIdNotEquals);
        }
        if (contextIdSpecified !== undefined && contextIdSpecified !== null) {
            queryParameters = queryParameters.set('contextId.specified', <any>contextIdSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (moduleIdEquals !== undefined && moduleIdEquals !== null) {
            queryParameters = queryParameters.set('moduleId.equals', <any>moduleIdEquals);
        }
        if (moduleIdGreaterThan !== undefined && moduleIdGreaterThan !== null) {
            queryParameters = queryParameters.set('moduleId.greaterThan', <any>moduleIdGreaterThan);
        }
        if (moduleIdGreaterThanOrEqual !== undefined && moduleIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('moduleId.greaterThanOrEqual', <any>moduleIdGreaterThanOrEqual);
        }
        if (moduleIdIn) {
            moduleIdIn.forEach((element) => {
                queryParameters = queryParameters.append('moduleId.in', <any>element);
            })
        }
        if (moduleIdLessThan !== undefined && moduleIdLessThan !== null) {
            queryParameters = queryParameters.set('moduleId.lessThan', <any>moduleIdLessThan);
        }
        if (moduleIdLessThanOrEqual !== undefined && moduleIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('moduleId.lessThanOrEqual', <any>moduleIdLessThanOrEqual);
        }
        if (moduleIdNotEquals !== undefined && moduleIdNotEquals !== null) {
            queryParameters = queryParameters.set('moduleId.notEquals', <any>moduleIdNotEquals);
        }
        if (moduleIdSpecified !== undefined && moduleIdSpecified !== null) {
            queryParameters = queryParameters.set('moduleId.specified', <any>moduleIdSpecified);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ContextModuleDTO>>('get',`${this.basePath}/m8t/api/context-modules`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getContextModule
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContextModuleUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<ContextModuleDTO>;
    public getContextModuleUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContextModuleDTO>>;
    public getContextModuleUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContextModuleDTO>>;
    public getContextModuleUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getContextModuleUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContextModuleDTO>('get',`${this.basePath}/m8t/api/context-modules/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateContextModule
     * 
     * @param body contextModuleDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateContextModuleUsingPUT(body: ContextModuleDTO, observe?: 'body', reportProgress?: boolean): Observable<ContextModuleDTO>;
    public updateContextModuleUsingPUT(body: ContextModuleDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContextModuleDTO>>;
    public updateContextModuleUsingPUT(body: ContextModuleDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContextModuleDTO>>;
    public updateContextModuleUsingPUT(body: ContextModuleDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateContextModuleUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ContextModuleDTO>('put',`${this.basePath}/m8t/api/context-modules`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
